export async function sendDataAPI(
	{ jwtToken, ...params }: { jwtToken: string; [key: string]: string },
	url: string,
	method: string,
	body: string | FormData | undefined = undefined,
	contentType: string = 'application/json',
) {
	const data = {
		...params,
	};
	const queryString = new URLSearchParams(data).toString();
	const apiUrl = queryString ? `${url}?${queryString}` : url;

	let headers = {
		Authorization: `Bearer ${jwtToken}`,
	};

	if (contentType !== 'multipart/form-data') {
		headers = { ...headers, ...{ 'Content-Type': contentType } };
	}

	try {
		const response = await fetch(apiUrl, {
			headers: headers,
			method: method,
			body: body ? body : undefined,
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw new Error(errorData.message || `API error, please try again (code: ${response.status})`);
		}

		return response;
	} catch (error) {
		const errorMessage = {
			message: (error as Error).message,
		};

		return new Response(JSON.stringify(errorMessage), {
			status: 500,
			statusText: 'Internal Server Error',
			headers: { 'Content-Type': 'application/json' },
		});
	}
}
